import InputComponent from '../../components/InputComponent';
import OrderPackages from '../../components/orderPackages';

const SectionTwo = ({
	register,
	formData,
	setValue,
	control,
	selectedLocation,
	selectedServices,
	setSelectedServices,
	getValues,
}) => {
	const packageOptions = [
		{
			value: 'Basis',
			title: 'Basis',
			service: 'basis pakke',
		},
		{
			value: 'PlussLite',
			title: 'Pluss',
			service: 'lite område',
		},
		{
			value: 'PlussStor',
			title: 'Pluss',
			service: 'stort område',
		},
		{
			value: 'Signatur',
			title: 'Signatur',
			service: 'podcast / innhold',
		},
	];

	const selectedPackage = packageOptions.find(
		(option) => option.value === formData.packageChoice
	);
	console.log(selectedPackage);

	return (
		<div className='sectionTwo'>
			<div className='orderPackages'>
				<OrderPackages
					name='packageChoice'
					register={register}
					setValue={setValue}
					formData={formData}
					options={packageOptions}
					selectedLocation={selectedLocation}
					selectedServices={selectedServices}
					setSelectedServices={setSelectedServices}
					control={control}
					getValues={getValues}
				/>

				{selectedPackage && (
					<div className="tailoring-needs">
						<div className='header'>
							<h2>Trenger du skreddersøm?</h2>
						</div>

						<div className='checkbox-wrapper'>
							<input
								id="tailoring-needs"
								name="tailoringNeeds"
								type='checkbox'
								{...register('tailoringNeeds')}
								className='focus:ring-blue-500 h-5 w-5 text-blue-600 border-gray-300 rounded'
							/>
							<label htmlFor="tailoring-needs" className='font-medium checkbox-label'>
								Ja.
							</label>
						</div>
					</div>
				)}


				{selectedPackage?.value === 'Basis' && (
					<div className="basisPackageContainer">

					</div>
				)}

				{selectedPackage && getValues && getValues('tailoringNeeds') && (
					<div className='contactPackage'>
						<div className='header'>
							<h2>
								Ta kontakt for <span>skreddersøm</span>
							</h2>
							<p>
								Legg igjen kontaktinformasjon. Du vil bli
								kontaktet i løpet av kort tid.
							</p>
						</div>

						<div className='inputs flex-row'>
							<div className='input'>
								<InputComponent
									label='Ditt navn'
									// required
									name='packageContactName'
									type='text'
									register={register}
								/>
							</div>
							<div className='input'>
								<InputComponent
									label='Telefon'
									// required
									name='packageContactPhone'
									type='tel'
									register={register}
								/>
							</div>
							<div className='input'>
								<InputComponent
									label='E-Post'
									// required
									name='packageContactEmail'
									type='email'
									register={register}
								/>
							</div>
						</div>
					</div>
				)}
			</div>
		</div>
	);
};

export default SectionTwo;
